import React from "react";
import Img from "../assets/resources/test_screen_layout.png"

export default function TestFullHD() {
    return (
        <div class="d-flex flex-column justify-content-center align-items-center bg-dark-cyan" style={{ width: "1080px", height: "1300px" }}>
            <img alt="img" src={Img} width="1080px" />
        </div>
    )
}